import { generatePath } from 'react-router-dom';
import Api from 'domain/api';

import { storage } from 'lib/storage';
import { GRID_PER_PAGE_DEFAULT } from 'domain/documents/constants';
import ROUTES_PATH from 'domain/router/routesPathConfig';

export const getPaymentsGridPerPage = () => {
  const stored = storage().paymentsAgGridPerPage().get();

  return stored ? JSON.parse(stored) : GRID_PER_PAGE_DEFAULT;
};

export const setPaymentsGridPerPage = (value: number): void => {
  storage().paymentsAgGridPerPage().set(JSON.stringify(value));
};

export function getPaymentUrl(companyId: string, paymentId: string): string {
  return generatePath(ROUTES_PATH.PAY_PAYMENT.absolute, {
    companyId,
    paymentId,
  });
}

export function getPaymentPreviewSrc(companyId: string, paymentId: string): string {
  return Api.getPaymentThumbnailUrl({
    companyId,
    paymentId,
  });
}
